import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors, withFetch } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { HttpClient } from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { SpanishPaginatorIntl } from './services/paginator-intl.service';

// Registrar locale español
registerLocaleData(localeEs, 'es');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }), 
        provideRouter(routes), 
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([authInterceptor]),
            withFetch()
        ),
        { provide: LOCALE_ID, useValue: 'es' },
        { provide: MatPaginatorIntl, useClass: SpanishPaginatorIntl },
        ErrorInterceptor,
        provideMarkdown({ loader: HttpClient })
    ]
};